import { render, staticRenderFns } from "./tip-steps.vue?vue&type=template&id=1baac758&scoped=true"
import script from "./tip-steps.vue?vue&type=script&lang=js"
export * from "./tip-steps.vue?vue&type=script&lang=js"
import style0 from "./tip-steps.vue?vue&type=style&index=0&id=1baac758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baac758",
  null
  
)

export default component.exports